<button mat-raised-button style="width: 100px" matTooltip="View Recipients" fxFlex matTooltipPosition="right"
  color="primary" (click)="viewRecipients()">
  <!-- <mat-icon>visibility</mat-icon> -->
  {{params.node.data.num_recipients}}
</button>